import React from "react";

const ErrorComponent = () => {
    return (
        <div className="text-red-500 bg-red-200 round-md">
            Look like component is error
        </div>
    );
};

export default ErrorComponent;